const model = {
    profileSubmitting: false,
    passwordSubmitting: false,
    errors: null,
    profile: null,
    passwordSuccess: false,
    success: false,
};

export default model;